<div class="product-image position-relative">
  <mercury-badge [badge]="badge" *ngFor="let badge of _badges"></mercury-badge>

  <img
    height="400"
    width="416"
    [ngClass]="{
      nopad:
        product.type.includes('Sleeve') || product.tags!.includes('nopadding')
    }"
    class="w-100 h-auto"
    [ngSrc]="product.image"
    ngSrcset="400w, 500w, 600w"
    [loaderParams]="{ aspect: 1.2, crop: false }"
  />
</div>
<div class="d-flex flex-column product-meta p-x">
  <div
    class="flex-column flex-lg-row d-flex justify-content-lg-between align-items-lg-center"
  >
    <div class="product-title h6 mb-0">
      {{ product.title | titleExtractor }}
    </div>

    <div class="product-prices d-flex flex-row">
      <div
        *ngIf="
          product.prices[currency]?.compare_at_price >
          product.prices[currency]?.price
        "
        class="price strike h6 mb-0"
      >
        {{ product.prices[currency].compare_at_price | currency }}
      </div>
      <div class="price h6 mb-0">
        {{ product.prices[currency]?.price | currency }}
      </div>
    </div>
  </div>
  <div
    *ngIf="product.title.includes(' | ')"
    class="product-subtitle flex-row d-flex justify-content-start align-items-center"
  >
    <ng-container *ngIf="product.title.split('|').length > 4; else shortTitle">
      <span class="title-segment me-2">{{ product.title.split("|")[3] }}</span>
      <span class="title-segment me-2">{{
        product.title.split("|")[4].split("/").join(" / ")
      }}</span>
    </ng-container>
    <ng-template #shortTitle>
      <span class="title-segment me-2">{{ product.title.split("|")[3] }}</span>
    </ng-template>
  </div>
  <div
    *ngIf="_related"
    class="flex-row d-lg-flex justify-content-start align-items-center related mt-3 d-none"
  >
    <div
      [style.backgroundColor]="entry.image ? 'transparent' : entry.color"
      class="related-entry"
      [routerLink]="['/products/' + entry.handle]"
      *ngFor="let entry of _related.slice(0, 4)"
    >
      <img
        *ngIf="entry.image"
        height="50"
        width="50"
        [ngSrc]="entry.image"
        ngSrcset="40w, 50w, 60w"
        [loaderParams]="{ aspect: 1 }"
      />
    </div>

    <div
      class="related-entry d-flex justify-content-center align-items-center"
      [routerLink]="['/products/' + product.handle]"
      *ngIf="_related.length > 4"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line x1="12" y1="19" x2="12" y2="5" stroke="black" />
        <line x1="19" y1="12" x2="5" y2="12" stroke="black" />
      </svg>
    </div>
  </div>
</div>
